import { render } from "./PlacementSetting.vue?vue&type=template&id=10aa155d&ts=true"
import script from "./PlacementSetting.vue?vue&type=script&lang=ts"
export * from "./PlacementSetting.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__